<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-bi">Acknowledgments</span></p>
<p class="tni">I would like to thank John and Renee Grisham, whose support of the Southern Writer in Residence program at the University of Mississippi enabled me to revise this novel. My wife, Win-borne, and my children, Robert and Tom, deserve credit for their patience and support. For advice on the manuscript, I owe a debt to both Reagan Arthur and Peter Matson. I would also like to thank the National Endowment for the Arts and Southeastern Louisiana University for their support.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?67c361f0